import styles from './ProfileQuickNav.module.css';

/**
 * A jump strip to the profile's own sections (First Visual Build mission).
 *
 * Detailed-mode only (Mission 171): Snapshot is a single short screen with
 * no long page to jump around within, so this never mounts there — see
 * `EmployeeProfilePage.tsx`'s `DetailedProfile`. The profile is one long
 * page by design — independent requests that fail independently, per
 * `EmployeeProfilePage`'s own note — so this adds orientation without
 * changing how or when anything loads: every target id already exists on
 * the section it names (`FactSection`'s `id` prop, and the matching ids on
 * Attributes/Role Fit/Potential/Readiness/Development/Career), and a link
 * to a section that is not on the page (because, say, the attribute
 * library is empty) simply does not scroll, rather than erroring.
 */
const PROFILE_SECTIONS: ReadonlyArray<{ id: string; label: string }> = [
  { id: 'attributes', label: 'Attributes' },
  { id: 'skills', label: 'Skills' },
  { id: 'experience', label: 'Experience' },
  { id: 'qualifications', label: 'Qualifications' },
  { id: 'achievements', label: 'Achievements' },
  { id: 'documents', label: 'Documents' },
  { id: 'traits', label: 'Traits' },
  { id: 'capabilities', label: 'Capabilities' },
  { id: 'role-fit', label: 'Role Fit' },
  { id: 'potential', label: 'Potential' },
  { id: 'readiness', label: 'Readiness' },
  { id: 'talent-designation', label: 'Designation' },
  { id: 'development', label: 'Development' },
  { id: 'career-aspirations', label: 'Career' },
];

export function ProfileQuickNav() {
  return (
    <nav className={styles.quickNav} aria-label="Jump to profile section">
      {PROFILE_SECTIONS.map((section) => (
        <a key={section.id} href={`#${section.id}`} className={styles.item}>
          {section.label}
        </a>
      ))}
    </nav>
  );
}
